import { ReactNode } from 'react';
import { Divider, Space } from 'antd';
import { H2 } from 'components/new-ui/base/typography/styles';
import { StyledIconWrapper } from 'components/new-ui/base/form/styles';
import { StyledFormSectionWrapper } from '../multistep-form/styles';

type Props = {
    title: string;
    icon: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
};

const FeatureGuidePanel = ({ icon, title, children, footer }: Props) => {
    return (
        <StyledFormSectionWrapper>
            <Space>
                <StyledIconWrapper style={{ fontSize: 14 }}>{icon}</StyledIconWrapper>
                <H2>{title}</H2>
            </Space>
            <Divider style={{ marginBlock: 12 }} />
            {children}
            {footer && (
                <>
                    <Divider style={{ marginBlock: 12 }} />
                    {footer}
                </>
            )}
        </StyledFormSectionWrapper>
    );
};

export default FeatureGuidePanel;
